import { Order, TableItem } from "./TableItem";

const columns = [
  {
    title: "Data/Hora",
    key: "date",
  },
  {
    title: (
      <>
        ID pedido
        <br /> na origem
      </>
    ),
    key: "origin_order_id",
  },
  {
    title: "Pagador",
    key: "pacient",
  },
  {
    title: "CPF",
    key: "cpf",
  },
  {
    title: "E-mail",
    key: "email",
  },
  {
    title: "Tipo de coleta",
    key: "home_collected",
  },
  {
    title: "Parceiro",
    key: "client",
  },
  {
    title: "Motion",
    key: "integration",
    className: "table-action-order",
  },
  {
    title: "Valor final",
    key: "paid_value",
  },
  {
    title: "",
    key: "action",
    className: "table-action-order",
  },
];

interface TableItemsProps {
  orders: Order[];
}
export const TableItems = ({ orders }: TableItemsProps) => {
  return (
    <div className="page-content-list">
      <table className="table-content small-separate details">
        <thead>
          <tr>
            {columns.map((columnsItem) => (
              <th key={columnsItem.key}>{columnsItem.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {orders.map((item) => (
            <TableItem key={item.order_id} order={item} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
